import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-layout-layout-horizontal-icon',
  templateUrl: './layout-layout-horizontal.component.html'
})
export class LayoutLayoutHorizontalComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
